import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserStore } from "../../store/userStore";
import { useCartStore } from "../../store/cartStore";
import { clearAllStores } from "../../store/clearAllStores";
import "bootstrap/dist/css/bootstrap.min.css";

type HeaderProps = {
  itemsCount?: number;
};

const Header: React.FC<HeaderProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();

 
  const user = useUserStore((s) => s.user);
  const username = user?.username || "User";
  const role = String(user?.role ?? "").trim().toUpperCase();
  console.log("role",role)
  const isVendor = role.includes("VENDOR");
  const isAuthor = role === "OEM";
  const isReviewer = role === "REVIEWER" || role === "OEMREVIEWER";

  const isAdmin = role === "SUPERADMIN" || role === "AUTHOR";
  


  const brandColor = "#1F2937";

  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  ////////////////////////////
  const accessToken = useUserStore((s) => s.accessToken);


  const itemsCount = useCartStore((s) => s.itemsCount ?? 0);
  const cartCountLabel = itemsCount > 99 ? "99+" : String(itemsCount || 0);

  console.log("itemsCount",itemsCount)
    console.log("isVendor",isVendor)
  const initOnLogin = useCartStore((s) => s.initOnLogin);
  const loadSummary = useCartStore((s) => s.loadSummary);

   useEffect(() => {
    if (accessToken) void initOnLogin();
  }, [ , initOnLogin]);

  const getCurrentPath = () => `${location.pathname}${location.search}`;
  const handleCartIconClick = () => navigate("/cart", { state: { from: getCurrentPath() } });

  const handleCartNumberClick = async () => {

    console.log("handleCartNumberClick..")
    await loadSummary();
    const { openCartId } = useCartStore.getState();
    navigate(openCartId ? `/cart/${openCartId}` : "/cart", {
      state: { from: getCurrentPath() },
    });
  };

  ////////////////////////////

  const toggleMenu = () => setShowMenu((prev) => !prev);

  const handleLogout = () => {
    clearAllStores();
    navigate("/", { replace: true });
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

let menuItems: { label: string; path?: string }[] = [];

if (isVendor) {
  // Vendor-specific menu
  menuItems = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Components", path: "/components" },
    { label: "Search", path: "/search" },
    { label: "Cart", path: "/cart" },
    { label: "Help", path: "/help" },
    
  ];
} else if (isReviewer) {
  menuItems = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Search", path: "/search" },
    { label: "Review", path: "/review" },
    { label: "Cart", path: "/cart" },
    { label: "Help", path: "/help" },
  ];
} else if (isAuthor) {
  // Authoring or SuperAdmin
  menuItems = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Components", path: "/components" },
    { label: "Search", path: "/search" },
    { label: "Review", path: "/review" },
    { label: "Cart", path: "/cart" },
    { label: "Vendors", path: "/vendors" },
    { label: "Part Pricing", path: "/partprice" },
    { label: "Help", path: "/help" },
  ];
}else if (isAdmin) {
  // Authoring or SuperAdmin
  menuItems = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Components", path: "/components" },
    { label: "Search", path: "/search" },
    { label: "Authoring", path: "/authoring" },
    { label: "Review", path: "/review" },
    { label: "Cart", path: "/cart" },
    { label: "Vendors", path: "/vendors" },
    { label: "Part Pricing", path: "/partprice" },
    { label: "Help", path: "/help" },
  ];
} else {
  // Default fallback menu
  menuItems = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Search", path: "/search" },
    { label: "Cart", path: "/cart" },
    { label: "Help", path: "/help" },
  ];
}


  return (
    <nav className="navbar navbar-expand-md main-navbar" style={{ height: "var(--header-h)" }}>
      <div className="container-fluid">
        {/* Logo + brand */}
        <div className="header-brand d-flex align-items-center gap-2">
          <img
            className="header-product-logo"
            src="/niquilllogosmall.png"
            alt="Niquill logo"
            style={{ width: 60, height: 66, objectFit: "contain" }}
          />
          <span className="navbar-brand fw-bold mb-0" style={{ color: brandColor, fontSize: 26 }}>
            ni Author
          </span>
          <span className="header-brand-divider fw-semibold" style={{ color: brandColor }}>
            ✦
          </span>
          <img
            className="header-customer-logo"
            src="/customerlogo.jpeg"
            alt="Customer logo"
            style={{ width: 115, height: 55, objectFit: "contain" }}
          />
        </div>

        {/* Mobile toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#headerNav"
          aria-controls="headerNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menus + User */}
        <div className="collapse navbar-collapse" id="headerNav">
          {/* Menus */}
<ul className="navbar-nav ms-auto mb-2 mb-md-0">
  {menuItems.map((item) => (
    <li className="nav-item" key={item.label}>
      <span
        className={`nav-link${item.path && location.pathname === item.path ? " is-active" : ""}`}
        onClick={() =>
          item.path &&
          navigate(
            item.path,
            item.path.startsWith("/cart")
              ? { state: { from: getCurrentPath() } }
              : undefined
          )
        }
      >
        {item.label}
        {item.label === "Cart" && isVendor && (
          <span
            className="ms-2"
            onClick={(e) => {
              e.stopPropagation();
              void handleCartNumberClick();
            }}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 24,
              height: 24,
              padding: "0 8px",
              borderRadius: 999,
              background: "#003366",
              color: "#ffffff",
              fontWeight: 700,
              fontSize: 12,
              lineHeight: 1,
              border: "1px solid #001f3d",
              boxShadow: "0 1px 4px rgba(0, 0, 0, 0.18)",
              cursor: "pointer",
            }}
          >
            {cartCountLabel}
          </span>
        )}
      </span>
    </li>
  ))}
</ul>

          {/* User card */}
          <div ref={menuRef} className="header-user position-relative ms-4">
            <div
              title={username}
              onClick={toggleMenu}
              className="d-flex align-items-center px-3 py-1 rounded-pill"
              style={{
                background: "linear-gradient(90deg, #1976d2, #db2777)",
                cursor: "pointer",
                color: "#fff",
                gap: 8,
              }}
            >
              <div
                aria-hidden
                className="d-flex align-items-center justify-content-center rounded-circle bg-white text-dark fw-bold"
                style={{ width: 24, height: 20, fontSize: 12 }}
              >
                {username.substring(0, 1).toUpperCase()}
              </div>
              <div className="header-user-details d-none d-md-flex flex-column lh-sm">
                <span className="fw-semibold text-white text-truncate" style={{ maxWidth: 120 }}>
                  {username}
                </span>
                <span className="small text-light opacity-75">{role || "—"}</span>
              </div>
            </div>

            {showMenu && (
            <div
              className="position-absolute end-0 mt-2 bg-white border rounded shadow"
              style={{ minWidth: 160, zIndex: 100 }}
            >
              <button
                onClick={() => navigate("/profile")}
                className="dropdown-item"
                style={{ fontSize: 14 }}
              >
                👤 Profile
              </button>

              <div className="dropdown-divider"></div>

              <button
                onClick={handleLogout}
                className="dropdown-item text-danger"
                style={{ fontSize: 14 }}
              >
                🚪 Logout
              </button>
            </div>
          )}

          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
